import Amplify from '../amplify';
import fetch from './fetch.helper';

export const fetchUsers = () => fetch('get', 'users');

// export const getUserById = id => API.get(CONFIG.ALICE_API, `users/${id}`);
export const getUserById = (id) => fetch('get', `users/${id}`);

export const postUser = (form) => fetch('post', 'users', null, form);

export const deleteUser = (userId) => fetch('del', `users/${userId}`);

export const putUser = (userId, changes) => {
  return fetch('put', `users/${userId}`, null, changes);
};

export const putUserData = (userId, changes) =>
  fetch('put', `users/${userId}`, null, changes);

export const signup = (form) => {
  const email = form.emailAddress.toLowerCase();
  return Amplify.Auth.signUp(email, form.password)
    .then((savedUser) => {
      delete form.password;
      delete form.confirmPassword;
      return postUser({
        ...form,
        userId: savedUser.userSub,
      });
    })
    .catch((err) => console.log(err));
};

export const checkForEmail = (email) =>
  fetch('get', `email/${email.trim().toLowerCase()}`);
